import { render, staticRenderFns } from "./SyncDB.vue?vue&type=template&id=d0957db0&"
import script from "./SyncDB.vue?vue&type=script&lang=js&"
export * from "./SyncDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports